import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=9bae2884&scoped=true&"
import script from "./pageHeader.vue?vue&type=script&lang=js&"
export * from "./pageHeader.vue?vue&type=script&lang=js&"
import style0 from "./pageHeader.vue?vue&type=style&index=0&id=9bae2884&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bae2884",
  null
  
)

export default component.exports